<template>
  <div
    style="height: 500px"
    class="eu-display_flex eu-align-items_center_md eu-justify_center eu-pa_6"
  >
    <emd-loader type="_invert" />
  </div>
</template>

<script>
import { EmdLoader } from 'emerald-vue/src/components'

export default {
  name: 'OnboardingLoading',

  components: {
    EmdLoader
  }
}
</script>
